// Imports
import Layout from '@/components/layout/Layout'
import { MTSharedRouteTabs } from '@/multi-territory/mt-components/mt-shared/MTSharedRouteTabs'
import { MTAdminTabs } from '@/multi-territory/mt-configs/mt-shared-route-tabs'
import { Box } from '@mui/material'
import { Outlet } from 'react-router'

export function MTAdmin() {
  // Return
  return (
    <Layout>
      <Box sx={{ mt: 2 }}>
        <MTSharedRouteTabs tabs={MTAdminTabs} />
        <Outlet />
      </Box>
    </Layout>
  )
}
